import './dom.css';

/*******************************************************************************
 * @ngdoc    directive
 * @module   csm.books.dom
 * @name     csm.books.dom.directive:percentInput
 * @property {integer} precision    Formatter decimal precision, default=0.
 * @property {boolean} includeSign  `true`=add percent (%) sign to end of output.
 * @restrict A
 * @require  ngModel
 * @description
 * Attribute for text input to be formatted and parsed as a percentage. Model
 * value is converted from decimal percentage (1.0 = 100%) and formatted to
 * `precision` decimal places for user input. User input value is converted back
 * to decimal percentage and rounded to `precision`+2 decimal places.
 * Example: Model value 0.572 is formatted as 57.2% and input value of 8.125% is
 * converted to model value .08125.
 *******************************************************************************/
/* @ngInject */ export function PercentInputDirective($filter, Tools) {
  return {
    scope: { precision: '<percentPrecision', includeSign: '<percentSign' },
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, elem, attrs, ngModel) {
      var precision = function () {
        return !isNaN(scope.precision) ? scope.precision : 0;
      };
      var formatter = function (modelValue) {
        return $filter('percent')(
          parseFloat(modelValue),
          precision(),
          scope.includeSign
        );
      };

      ngModel.$formatters.unshift(formatter);
      ngModel.$parsers.unshift(function (viewValue) {
        return Tools.roundToPrecision(
          parseFloat(viewValue) / 100,
          precision() + 2
        );
      });

      /*-------------------------------------------------------------------------*/
      /* Update the element value with the formatted model value when            */
      /* caret leaves the field.                                                 */
      /*                                                                         */
      /* Note: `ngModelOptions.updateOn:'blur'` does not work in angular-ui-grid */
      /*       since it destroys the editor element before the `blur` is seen.   */
      /*                                                                         */
      /* TODO: In the latest version (1.7) of AngularJS, this can be done with a */
      /* TODO: call to `ngModel.$processModelValue()`.                           */
      /*-------------------------------------------------------------------------*/
      elem.bind('blur', function () {
        elem.val(formatter(ngModel.$modelValue));
      });
    }
  }
}
